import { Button } from "../../../../components/ui/button";
import { Input } from "../../../../components/ui/input";
import { useStepper } from "../../../../components/ui/stepper";
import { Mail } from "lucide-react";
import React from "react";
import { API, post } from "../../../../config";

const Step3 = ({ setLoading, setBackupEmail, backupEmail }) => {
  const { nextStep, prevStep } = useStepper();

  const changeBackupEmail = (event) => {
    setBackupEmail(event.target.value);
  };

  const confirmCode = async (e) => {
    e.preventDefault();
    let params = { backup_email: backupEmail };
    setLoading(true);
    post(API.ADD_BACKUP_EMAIL, params)
      .then(() => {
        nextStep();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <form
      onSubmit={confirmCode}
      className="flex flex-col items-center justify-center md:min-w-[350px] gap-4"
    >
      <p className="flex items-center text-lg font-bold">
        <span className="mr-2">
          <Mail height={30} width={30} />
        </span>
        Add a backup email
      </p>
      <p className="text-center">
        This email is only used to log into your account if you&apos;re locked
        out or don&apos;t have your phone.
      </p>
      <p>It must be different to the email you log in with.</p>
      <Input
        id="email"
        name="email"
        type="email"
        placeholder="Enter Backup Email"
        required
        onChange={(e) => changeBackupEmail(e)}
        value={backupEmail}
      />
      <div className="flex gap-2">
        <Button type="submit">Confirm</Button>
        <Button variant="outline" size="default" onClick={() => prevStep()}>
          Back
        </Button>
      </div>
    </form>
  );
};

export default Step3;
